<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » エントリー情報詳細（編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>エントリー情報詳細（編集）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/entrance-exit-entry-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> イベント、エントリー番号、登録日時、更新日時、メール送信状況
        </div>
        <div class="manual-explain">
          エントリー情報を表示します。読み取り専用で変更はできません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> エントリー情報基本項目
        </div>
        <div class="manual-explain">
          エントリー情報の各基本項目を編集することができます。<br>
          <span class="manual-explain-notes">※メールアドレスは必須</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> エントリー情報カスタム項目
        </div>
        <div class="manual-explain">
          エントリー情報の各カスタム項目を編集することができます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Entry Information Details (Edit)
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Entry Information Details (Edit)</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_entrance-exit-entry-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Event, Entry Number, Registration Date/Time, Update Date/Time, Email Send Status
        </div>
        <div class="manual-explain">
          Displays entry information. Read-only and cannot be changed.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Entry Information Basic Items
        </div>
        <div class="manual-explain">
          You can edit each basic item of the entry information.<br>
          <span class="manual-explain-notes">*Email address is required</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Entry Information Custom Items
        </div>
        <div class="manual-explain">
          You can edit each custom item of the entry information.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Update Button
        </div>
        <div class="manual-explain">
          Click to update the edited content.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
